import { render, staticRenderFns } from "./FreeShippingNotice.vue?vue&type=template&id=0ae98987&scoped=true&"
import script from "./FreeShippingNotice.vue?vue&type=script&lang=js&"
export * from "./FreeShippingNotice.vue?vue&type=script&lang=js&"
import style0 from "./FreeShippingNotice.vue?vue&type=style&index=0&id=0ae98987&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae98987",
  null
  
)

export default component.exports